import { render } from "./bolt.svg?vue&type=template&id=529534c3?inline"
const script = {}
script.render = render

export default script